module.exports = __webpack_public_path__ + "0b54e50290bfc17368dc45520a9efe81.svg";